/**
 * File: it_IT.js
 * Project: Noname-Base-Frontend
 * File Created: Friday, 25th October 2024 11:40:55 am
 * Author: Daniel Rodríguez Cabrera (daniel.rodriguez@aerin.es)
 * Version: 2.0.0
 * -----
 * Last Modified: Monday, 4th August 2025 1:29:20 pm
 * Modified By: Alexandru Ionut Dascalu
 * -----
 * Copyright (c) 2023 - 2024 Aerin Sistemas S. L. copying, distribution or modification not authorised in writing is prohibited.
 */

/* Textes de langue Gogo

Table des matières

01.Général
02.Connexion, déconnexion, inscription de l'utilisateur
03.Menu
04.Tableaux de bord
05.Pages
06.Applications
  06.01.Chat
  06.02.Sondage
  06.03.Tâches à faire
07.UI
  07.01.Alertes
  07.02.Badges
  07.03.Boutons
  07.04.Cartes
  07.05.Carrousel
  07.06.Graphiques
  07.07.Réduire
  07.08.Menus déroulants
  07.09.Éditeurs
  07.10.Formulaires
  07.11.Composants de formulaire
  07.12.Icônes
  07.13.Groupes de champs d'entrée
  07.14.Jumbotron
  07.15.Modal
  07.16.Navigation
  07.17.Popover & Info-bulle
  07.18.Triable
  07.19.Cartes
  07.20.Tableaux
  07.21.Assistants
  07.22.Erreurs
*/

module.exports = {
  /* 01.Generale */
  'general.copyright': 'Noname © 2022 Tutti i diritti riservati.',
  'general.project-name': 'NONAME',

  'unauthorized.title': 'Tentativo di accesso non autorizzato',
  'unauthorized.detail':
    'Non sei autorizzato a visualizzare la pagina a cui stai cercando di accedere.',

  /* 02.Accesso utente, logout, registrazione */
  'user.login-title': 'Accedi',
  'user.register': 'Registrazione',
  'user.forgot-password': 'Hai dimenticato la password',
  'user.email': 'Email',
  'user.password': 'Password',
  'user.forgot-password-question': 'Password dimenticata?',
  'user.fullname': 'Nome completo',
  'user.login-button': 'ACCEDI',
  'user.login-sso': 'Accedi con SSO',
  'user.sso-redirecting': 'Reindirizzamento...',
  'user.sso-authenticating': 'Autenticazione...',
  'user.sso-error':
    "Accesso SSO non riuscito. Verifica che il tuo utente abbia accesso all'applicazione o accedi con nome utente e password.",
  'user.sso-error-user-not-found':
    "Il tuo account non è registrato nell'applicazione. Contatta l'amministratore per ottenere l'accesso.",
  'user.sso-error-inactive':
    "Il tuo utente è disattivato. Contatta l'amministratore.",
  'user.register-button': 'REGISTRATI',
  'user.reset-password-button': 'REIMPOSTA',
  'user.buy': 'ACQUISTA',
  'user.username': 'Nome utente',
  'user.new-password-again': 'Nuova password di nuovo',
  'user.new-password': 'Nuova Password',
  'user.reset-password': 'Reimposta la password',
  'user.warning-message': 'Utilizza le tue credenziali per accedere.',
  'user.error.internal-server': 'Errore interno del server. Riprova più tardi.',
  'user.error.invalid-credentials':
    'Credenziali non valide. Controlla il tuo nome utente e la tua password.',
  'user.error.generic': 'Si è verificato un errore. Riprova.',
  'user.error.no-response':
    'Nessuna risposta dal server. Controlla la tua connessione o riprova più tardi.',
  'user.error.config-request': 'Errore di configurazione della richiesta.',
  'user.error.login': 'Errore di accesso.',
  'user.error.expired-token': 'Token di sessione scaduto.',

  /* 03.Menu */
  'menu.home': 'Home',
  'menu.app': 'Home',
  'menu.dashboards': 'Dashboard',
  'menu.default': 'Predefinito',
  'menu.analytics': 'Analisi',
  'menu.ecommerce': 'E-commerce',
  'menu.content': 'Contenuto',
  'menu.pages': 'Pagine',
  'menu.administration': 'Amministrazione',
  'menu.audits': 'Audit',
  'menu.accounts': 'Utenti',
  'menu.data-list': 'Lista Dati',
  'menu.thumb-list': 'Lista Miniature',
  'menu.image-list': 'Lista Immagini',
  'menu.details': 'Dettagli',
  'menu.search': 'Ricerca',
  'menu.login': 'Accedi',
  'menu.register': 'Registrati',
  'menu.forgot-password': 'Password dimenticata',
  'menu.reset-password': 'Reimposta Password',
  'menu.error': 'Errore',
  'menu.applications': 'Applicazioni',
  'menu.todo': 'Note',
  'menu.survey': 'Sondaggio',
  'menu.chat': 'Chat',
  'menu.ui': 'UI',
  'menu.alerts': 'Avvisi',
  'menu.badges': 'Badge',
  'menu.buttons': 'Pulsanti',
  'menu.cards': 'Schede',
  'menu.carousel': 'Carosello',
  'menu.charts': 'Grafici',
  'menu.collapse': 'Comprimi',
  'menu.dropdowns': 'Menu a discesa',
  'menu.editors': 'Editor',
  'menu.form-layouts': 'Layout Moduli',
  'menu.form-components': 'Componenti Modulo',
  'menu.form-validations': 'Validazioni Modulo',
  'menu.form-wizard': 'Assistente Modulo',
  'menu.icons': 'Icone',
  'menu.input-groups': 'Gruppi di Input',
  'menu.jumbotron': 'Jumbotron',
  'menu.modal': 'Modale',
  'menu.navigation': 'Navigazione',
  'menu.popover-tooltip': 'Tooltip e Popover',
  'menu.sortable': 'Ordinabile',
  'menu.tables': 'Tabelle',
  'menu.menu': 'Menu',
  'menu.subhidden': 'Sub nascosto',
  'menu.hidden': 'Nascosto',
  'menu.visible': 'Visibile',
  'menu.maps': 'Mappe',
  'menu.landingpage': 'Pagina di destinazione',
  'menu.multipage-home': 'Multipagina',
  'menu.singlepage-home': 'Pagina singola',
  'menu.about': 'Informazioni',
  'menu.auth-login': 'Autenticazione',
  'menu.auth-register': 'Registrazione',
  'menu.blog': 'Blog',
  'menu.blog-list': 'Elenco Blog',
  'menu.blog-detail': 'Dettaglio Blog',
  'menu.careers': 'Carriere',
  'menu.confirmation': 'Conferma',
  'menu.contact': 'Contatto',
  'menu.docs': 'Documentazione',
  'menu.features': 'Caratteristiche',
  'menu.prices': 'Prezzi',
  'menu.videos': 'Video',
  'menu.mailing': 'Posta',
  'menu.invoice': 'Fattura',
  'menu.blank-page': 'Pagina Vuota',
  'menu.types': 'Tipi di Menu',
  'menu.levels': 'Livelli Menu',
  'menu.third-level-1': 'Terzo Livello 1',
  'menu.third-level-2': 'Terzo Livello 2',
  'menu.third-level-3': 'Terzo Livello 3',
  'menu.faq': 'FAQ',
  'menu.knowledge-base': 'Base di Conoscenza',
  'menu.authorization': 'Autorizzazione',
  'menu.profile': 'Profilo',
  'menu.product': 'Prodotto',
  'menu.miscellaneous': 'Varie',
  'menu.portfolio': 'Portfolio',
  'menu.social': 'Social',
  'menu.details-alt': 'Dettagli Alt',
  'menu.forms': 'Modulo',
  'menu.components': 'Componenti',
  'menu.layouts': 'Layout',
  'menu.validations': 'Validazioni',
  'menu.wizard': 'Assistente',

  /* Administration.accounts */
  'administration.accounts.create': 'Crea',
  'administration.accounts.cancel': 'Annulla',
  'administration.accounts.tittle.create': 'Crea un nuovo utente',
  'administration.accounts.username': 'Nome utente',
  'administration.accounts.email': 'Email',
  'administration.accounts.name': 'Nome',
  'administration.accounts.lastname': 'Cognome',
  'administration.accounts.password': 'Password',
  'administration.accounts.confirmpassword': 'Conferma password',
  'administration.accounts.staff': 'Staff',
  'administration.accounts.administrator': 'Amministratore',
  'administration.accounts.edit': 'Modifica',
  'administration.accounts.delete': 'Elimina',

  /* Administration.audits */
  'administration.audits.criticality': 'Criticità',
  'administration.audits.date': 'Data',
  'administration.audits.app': 'Applicazione',
  'administration.audits.application': 'Nome dell’applicazione',
  'administration.audits.message': 'Messaggio',

  /* 04.Dashboard */
  'dashboards.pending-orders': 'Ordini in sospeso',
  'dashboards.completed-orders': 'Ordini completati',
  'dashboards.refund-requests': 'Richiesta di rimborso',
  'dashboards.new-comments': 'Nuovi commenti',
  'dashboards.sales': 'Vendite',
  'dashboards.orders': 'Ordini',
  'dashboards.refunds': 'Rimborsi',
  'dashboards.recent-orders': 'Ordini recenti',
  'dashboards.product-categories': 'Categorie di prodotto',
  'dashboards.cakes': 'Torte',
  'dashboards.tickets': 'Biglietti',
  'dashboards.calendar': 'Calendario',
  'dashboards.best-sellers': 'Più venduti',
  'dashboards.website-visits': 'Visite al sito',
  'dashboards.unique-visitors': 'Visitatori unici',
  'dashboards.this-week': 'Questa settimana',
  'dashboards.last-week': 'La settimana scorsa',
  'dashboards.this-month': 'Questo mese',
  'dashboards.conversion-rates': 'Tassi di conversione',
  'dashboards.per-session': 'Per sessione',
  'dashboards.profile-status': 'Stato del profilo',
  'dashboards.payment-status': 'Stato del pagamento',
  'dashboards.work-progress': 'Lavori in corso',
  'dashboards.tasks-completed': 'Attività completate',
  'dashboards.payments-done': 'Pagamenti effettuati',
  'dashboards.order-stock': 'Ordini - Valori',
  'dashboards.categories': 'Categorie',
  'dashboards.quick-post': 'Pubblicazione rapida',
  'dashboards.title': 'Titolo',
  'dashboards.content': 'Contenuto',
  'dashboards.category': 'Categoria',
  'dashboards.save-and-publish': 'Salva e pubblica',
  'dashboards.top-viewed-posts': 'Post più visualizzati',
  'dashboards.posts': 'Post',
  'dashboards.pending-for-publish': 'In attesa di pubblicazione',
  'dashboards.users': 'Utenti',
  'dashboards.on-approval-process': 'In attesa di approvazione',
  'dashboards.alerts': 'Avvisi',
  'dashboards.waiting-for-notice': 'In attesa di notifica',
  'dashboards.files': 'File',
  'dashboards.pending-for-print': 'In attesa di stampa',
  'dashboards.logs': 'Log',
  'dashboards.gogo': 'GOGO',
  'dashboards.magic-is-in-the-details': 'LA MAGIA È NEI DETTAGLI',
  'dashboards.yes-it-is-indeed': 'Sì, è vero!',
  'dashboards.advanced-search': 'Ricerca avanzata',
  'dashboards.toppings': 'Condimenti',
  'dashboards.type': 'Categoria',
  'dashboards.keyword': 'Parola chiave',
  'dashboards.search': 'Ricerca',
  'dashboards.top-rated-items': 'Elementi più votati',

  /* 05.Schemi */
  'pages.add-new': 'AGGIUNGI NUOVO',
  'pages.add-new-modal-title': 'Aggiungi nuovo elemento',
  'pages.display-options': 'Opzioni di visualizzazione',
  'pages.orderby': 'Ordina per: ',
  'pages.total': 'Totale: ',
  'pages.viewing': 'Visualizzando: ',
  'pages.product-name': 'Nome del prodotto',
  'pages.category': 'Categoria',
  'pages.description': 'Descrizione',
  'pages.status': 'Stato',
  'pages.cancel': 'Annulla',
  'pages.submit': 'Invia',
  'pages.delete': 'Elimina',
  'pages.another-action': 'Altra azione',
  'pages.actions': 'AZIONI',
  'pages.header': 'Intestazione',
  'pages.details': 'DETTAGLI',
  'pages.orders': 'ORDINI',
  'pages.rating': 'Valutazione',
  'pages.price': 'Prezzo',
  'pages.ingredients': 'Ingredienti',
  'pages.is-vegan': 'È vegano',
  'pages.order-status': 'Stato dell’ordine',
  'pages.bake-progress': 'Avanzamento cottura',
  'pages.popularity': 'Popolarità',
  'pages.comments': 'Commenti',
  'pages.error-title': 'Ops, sembra che si sia verificato un errore!',
  'pages.error-code': 'Codice errore',
  'pages.go-back-home': 'TORNA ALLA HOME',
  'pages.mailing-info':
    'I template di posta utilizzano layout inline e tabelle per rendere bene su vari provider. Per una migliore usabilità, lo includiamo come HTML standard con dangerouslySetInnerHTML.',
  'pages.invoice-info':
    'Il template di fattura ha una versione inline per uso esterno e una versione React.',
  'pages.react-version': 'Versione React',
  'pages.inline-version': 'Versione Html Inline',
  'pages.like': 'Mi piace',
  'pages.likes': 'Mi piace',
  'pages.details-title': 'Dettagli',
  'pages.comments-title': 'Commenti',
  'pages.questions-title': 'Domande',
  'pages.similar-projects': 'Progetti simili',
  'pages.send': 'Invia',
  'pages.addComment': 'Aggiungi un commento',
  'pages.location': 'Posizione',
  'pages.responsibilities': 'Responsabilità',
  'pages.photos': 'Foto',
  'pages.who-to-follow': 'Chi seguire',
  'pages.follow': 'SEGUI',
  'pages.followers': 'SEGUACI',
  'pages.recent-posts': 'Post recenti',
  'pages.profile': 'PROFILO',
  'pages.friends': 'AMICI',
  'pages.images': 'IMMAGINI',
  'pages.purchase': 'ACQUISTA',
  'pages.price.developer': 'SVILUPPATORE',
  'pages.price.team': 'TEAM',
  'pages.price.enterprise': 'IMPRESA',
  'pages.price.twofactorauthentication': 'Autenticazione a due fattori',
  'pages.price.teampermissions': 'Permessi team',
  'pages.price.245Support': 'Supporto 24/5',
  'pages.price.247Support': 'Supporto 24/7',
  'pages.price.useractionsauditlog': 'Registro azioni utente',
  'pages.prices.featurecomparison': 'Confronto funzionalità',
  'pages.prices.pricecomparison': 'Confronto prezzi',

  /* 06.Applicazioni */

  /* 06.01.Chatta */
  'chat.messages': 'Messaggi',
  'chat.contacts': 'Contatti',
  'chat.saysomething': 'Di qualcosa...',

  /* 06.02.Sondaggi */
  'survey.delete': 'Elimina',
  'survey.edit': 'Modifica',
  'survey.add-new': 'AGGIUNGI NUOVO',
  'survey.add-new-title': 'Aggiungi Nuovo Sondaggio',
  'survey.title': 'Titolo',
  'survey.category': 'Categoria',
  'survey.label': 'Etichetta',
  'survey.status': 'Stato',
  'survey.cancel': 'Annulla',
  'survey.submit': 'Invia',
  'survey.another-action': 'Altra azione',
  'survey.display-options': 'Opzioni di Visualizzazione',
  'survey.orderby': 'Ordina per : ',
  'survey.all-surveys': 'Tutti i Sondaggi',
  'survey.completed-surveys': 'Sondaggi Completati',
  'survey.categories': 'Categorie',
  'survey.active-surveys': 'Sondaggi Attivi',
  'survey.labels': 'Etichette',

  /* 06.03.Note */
  'todo.add-new': 'AGGIUNGI NUOVO',
  'todo.add-new-title': 'Aggiungi Nuovo',
  'todo.title': 'Titolo',
  'todo.detail': 'Dettaglio',
  'todo.category': 'Categoria',
  'todo.label': 'Etichetta',
  'todo.status': 'Stato',
  'todo.cancel': 'Annulla',
  'todo.submit': 'Invia',
  'todo.action': 'Azione',
  'todo.another-action': 'Altra azione',
  'todo.display-options': 'Opzioni di Visualizzazione',
  'todo.orderby': 'Ordina per : ',
  'todo.all-tasks': 'Tutte le Attività',
  'todo.pending-tasks': 'Attività in Sospeso',
  'todo.completed-tasks': 'Attività Completate',
  'todo.categories': 'Categorie',
  'todo.labels': 'Etichette',

  /* 07.UI */

  /* 07.01.Allerte */
  'alert.rounded': 'Allerta Arrotondata',
  'alert.react-notifications': 'Notifiche React',
  'alert.outline': 'Contorno',
  'alert.primary': 'Primario',
  'alert.secondary': 'Secondario',
  'alert.info': 'Info',
  'alert.success': 'Successo',
  'alert.warning': 'Avviso',
  'alert.error': 'Errore',
  'alert.filled': 'Pieno',
  'alert.primary-text': 'Questo è un allarme primario—controlla!',
  'alert.secondary-text': 'Questo è un allarme secondario—controlla!',
  'alert.success-text': 'Questo è un allarme di successo—controlla!',
  'alert.danger-text': 'Questo è un allarme di pericolo—controlla!',
  'alert.warning-text': 'Questo è un allarme di avviso—controlla!',
  'alert.info-text': 'Questo è un allarme informativo—controlla!',
  'alert.light-text': 'Questo è un allarme leggero—controlla!',
  'alert.dark-text': 'Questo è un allarme scuro—controlla!',
  'alert.default': 'Allerta Predefinita',
  'alert.dismissing': 'Allerta da Ignorare',
  'alert.dismissing-text':
    'Mamma mia! Devi controllare alcuni di questi campi qui sotto.',
  'alert.dismissing-without-animate-text':
    'Sono un allarme che può essere ignorato senza animazione!',

  /* 07.02.Badge */
  'badge.sizes': 'Dimensioni',
  'badge.colors': 'Colori',
  'badge.outline': 'Contorno',
  'badge.links': 'Collegamenti',
  'badge.counter-badges': 'Badge Contatori',
  'badge.bootstrap-default': 'Bootstrap Predefinito',
  'badge.primary': 'Primario',
  'badge.secondary': 'Secondario',
  'badge.success': 'Successo',
  'badge.danger': 'Pericolo',
  'badge.warning': 'Avviso',
  'badge.info': 'Info',
  'badge.light': 'Chiaro',
  'badge.dark': 'Scuro',

  /* 07.03.Pulsanti */
  'button.default': 'Bootstrap Predefinito',
  'button.colors': 'Colori',
  'button.rounded': 'Pulsanti Arrotondati',
  'button.outline': 'Contorno',
  'button.states': 'Stati',
  'button.sizes': 'Dimensioni',
  'button.button-groups': 'Gruppi di Pulsanti',
  'button.large-button': 'Pulsante Grande',
  'button.small-button': 'Pulsante Piccolo',
  'button.extra-small-button': 'Pulsante Extra Piccolo',
  'button.block-button': 'Pulsante a Blocco',
  'button.active': 'Attivo',
  'button.disabled': 'Disabilitato',
  'button.basic': 'Base',
  'button.toolbar': 'Barra degli Strumenti',
  'button.nesting': 'Annidamento',
  'button.vertical-variation': 'Variazione Verticale',
  'button.checkbox-radio-button': 'Checkbox e Pulsanti Radio',
  'button.checkbox': 'Checkbox',
  'button.radio': 'Radio',
  'button.radio-button': 'Pulsante Radio',
  'button.primary': 'Primario',
  'button.secondary': 'Secondario',
  'button.success': 'Successo',
  'button.danger': 'Pericolo',
  'button.warning': 'Avviso',
  'button.info': 'Info',
  'button.light': 'Chiaro',
  'button.dark': 'Scuro',
  'button.states-text':
    'Questo pulsante mostra una rotellina per 2 secondi e un’icona di errore per 3 secondi prima di tornare allo stato normale. Gli stati si attivano aggiungendo o rimuovendo classi.',
  'button.click-here': 'Clicca qui',
  'button.states-text-alternate':
    'Questo pulsante mostra una rotellina per 2 secondi e un’icona di errore per 3 secondi prima di tornare allo stato normale. Gli stati si attivano aggiungendo o rimuovendo classi.',
  'button.primary-link': 'Link Primario',
  'button.link': 'Link',
  'button.primary-button': 'Pulsante Primario',
  'button.button': 'Pulsante',
  'button.left': 'Sinistra',
  'button.middle': 'Centro',
  'button.right': 'Destra',
  'button.dropdown': 'Menu a Discesa',
  'button.dropdown-link': 'Link a Discesa',

  /* 07.04.Carte */
  'cards.icon-card': 'Carta Icona',
  'cards.image-card': 'Carta Immagine',
  'cards.image-overlay-card': 'Carta con Sovrapposizione Immagine',
  'cards.image-card-list': 'Lista Carte Immagine',
  'cards.tab-card': 'Carta Tab',
  'cards.user-card': 'Carta Utente',

  /* 07.05.Carosello */
  'carousel.basic': 'Carosello Base',
  'carousel.single': 'Carosello Singolo',
  'carousel.without-controls': 'Carosello senza Controlli',

  /* 07.06.Grafici */
  'charts.line': 'Grafico a Linee',
  'charts.polar': 'Grafico Polare',
  'charts.area': 'Grafico ad Area',
  'charts.scatter': 'Grafico a Dispersione',
  'charts.bar': 'Grafico a Barre',
  'charts.radar': 'Grafico Radar',
  'charts.pie': 'Grafico a Torta',
  'charts.doughnut': 'Grafico a Ciambella',
  'charts.shadow': 'Ombra',
  'charts.no-shadow': 'Senza Ombra',

  /* 07.07.Collapse */
  'collapse.basic': 'Base',
  'collapse.toggle': 'Interruttore',
  'collapse.accordion': 'Fisarmonica',
  'collapse.controlled': 'Controllato',
  'collapse.uncontrolled': 'Non Controllato',

  /* 07.08.Menu a discesa */
  'dropdowns.basic': 'Base',
  'dropdowns.controlled': 'Controllato',
  'dropdowns.uncontrolled': 'Non Controllato',
  'dropdowns.dropdown': 'Menu a Discesa',
  'dropdowns.header': 'Intestazione',
  'dropdowns.action': 'Azione',
  'dropdowns.another-action': 'Altra Azione',
  'dropdowns.right': 'Destra',
  'dropdowns.left': 'Sinistra',
  'dropdowns.drop-directions': 'Direzioni Menu',
  'dropdowns.dropright': 'Menu a Destra',
  'dropdowns.dropleft': 'Menu a Sinistra',
  'dropdowns.small-button': 'Pulsante Piccolo',
  'dropdowns.large-button': 'Pulsante Grande',
  'dropdowns.sizing': 'Dimensionamento',
  'dropdowns.split-button': 'Pulsanti Menu a Discesa',
  'dropdowns.dropup': 'Menu a Salita',

  /* 07.09.Editori */
  'editors.draftjs': 'Draft.js',
  'editors.quill-standart': 'Quill Standard',
  'editors.quill-bubble': 'Quill Bubble',

  /* 07.10.Moduli */
  'forms.basic': 'Base',
  'forms.email': 'Email',
  'forms.email-muted': 'Non condivideremo mai la tua email con nessun altro.',
  'forms.password': 'Password',
  'forms.password-confirm': 'Conferma Password',
  'forms.submit': 'Invia',
  'forms.horizontal': 'Orizzontale',
  'forms.radios': 'Radio',
  'forms.first-radio': 'Prima Radio',
  'forms.second-radio': 'Seconda Radio',
  'forms.third-radio-disabled': 'Terza Radio Disabilitata',
  'forms.checkbox': 'Checkbox',
  'forms.signin': 'Accedi',
  'forms.top-labels-over-line': 'Etichette Sopra la Linea',
  'forms.tags': 'Tag',
  'forms.date': 'Data',
  'forms.state': 'Stato',
  'forms.top-labels-in-input': 'Etichette Dentro il Campo',
  'forms.email-u': 'EMAIL',
  'forms.password-u': 'PASSWORD',
  'forms.tags-u': 'TAG',
  'forms.date-u': 'DATA',
  'forms.state-u': 'STATO',
  'forms.grid': 'Griglia del Modulo',
  'forms.address': 'Indirizzo',
  'forms.address2': 'Indirizzo 2',
  'forms.city': 'Città',
  'forms.city-message': 'Seleziona una città!',
  'forms.state-message': 'Seleziona uno stato!',
  'forms.zip': 'CAP',
  'forms.signup': 'Registrati',
  'forms.inline': 'Inline',
  'forms.validation': 'Validazione',
  'forms.default': 'Predefinito',
  'forms.firstname': 'Nome',
  'forms.firstname-message': 'Per favore, inserisci il tuo nome!',
  'forms.lastname': 'Cognome',
  'forms.lastname-message': 'Per favore, inserisci il tuo cognome!',
  'forms.name': 'Nome',
  'forms.validation-availity': 'Validazione Availity Reactstrap',
  'forms.validation-formik': 'Validazione Formik',

  /* 07.11.Componenti del modulo */
  'form-components.custom-inputs': 'Input Personalizzato',
  'form-components.checkboxes': 'Checkbox',
  'form-components.radios': 'Radio',
  'form-components.inline': 'Inline',
  'form-components.react-select': 'React Select',
  'form-components.state-single': 'Stato Singolo',
  'form-components.state-multiple': 'Stato Multiplo',
  'form-components.react-autosuggest': 'React Autosuggest',
  'form-components.date-picker': 'Selettore di Data',
  'form-components.date': 'Data',
  'form-components.date-range': 'Intervallo di Date',
  'form-components.date-with-time': 'Data con Orario',
  'form-components.embedded': 'Incorporato',
  'form-components.dropzone': 'Dropzone',
  'form-components.drop-files-here': 'Trascina i file qui',
  'form-components.tags': 'Tag',
  'form-components.switch': 'Interruttore',
  'form-components.primary': 'Primario',
  'form-components.secondary': 'Secondario',
  'form-components.primary-inverse': 'Primario Inverso',
  'form-components.secondary-inverse': 'Secondario Inverso',
  'form-components.slider': 'Cursore',
  'form-components.double-slider': 'Doppio Cursore',
  'form-components.single-slider': 'Cursore Singolo',
  'form-components.rating': 'Valutazione',
  'form-components.interactive': 'Interattivo',
  'form-components.readonly': 'Sola Lettura',
  'form-components.type-a-cake': 'Scrivi una torta',
  'form-components.start': 'Inizio',
  'form-components.end': 'Fine',
  'form-components.tables': 'Tabelle',

  /* 07.12.Icone */
  'icons.simplelineicons': 'Icone Simple Line',
  'icons.iconsmind': 'Icone IconsMind',

  /* 07.13.Gruppi di Input */
  'input-groups.basic': 'Base',
  'input-groups.sizing': 'Dimensionamento',
  'input-groups.small': 'Piccolo',
  'input-groups.default': 'Predefinito',
  'input-groups.large': 'Grande',
  'input-groups.checkboxes-and-radios': 'Checkbox e Radio',
  'input-groups.multiple-inputs': 'Input Multipli',
  'input-groups.first-and-last-name': 'Nome e Cognome',
  'input-groups.multiple-addons': 'Addon Multipli',
  'input-groups.button-addons': 'Addon con Pulsante',
  'input-groups.button': 'Pulsante',
  'input-groups.buttons-with-dropdowns': 'Pulsanti con Menu a Discesa',
  'input-groups.dropdown': 'Menu a Discesa',
  'input-groups.header': 'Intestazione',
  'input-groups.action': 'Azione',
  'input-groups.another-action': 'Altra Azione',
  'input-groups.custom-select': 'Select Personalizzato',
  'input-groups.options': 'Opzioni',
  'input-groups.choose': 'Scegli...',
  'input-groups.custom-file-input': 'Input File Personalizzato',

  /* 07.14.Jumbotron */
  'jumbotron.hello-world': 'Ciao Mondo!',
  'jumbotron.lead':
    "Questa è una semplice unità hero, un componente jumbotron di base per attirare l'attenzione su contenuti o informazioni importanti.",
  'jumbotron.lead-detail':
    "Usa classi di utilità per tipografia e spaziatura per distanziare il contenuto all'interno del contenitore più grande.",
  'jumbotron.learn-more': 'Scopri di più',

  /* 07.15.Modale */
  'modal.basic': 'Base',
  'modal.modal-title': 'Titolo Modale',
  'modal.launch-demo-modal': 'Avvia Modale Demo',
  'modal.scrolling-long-content': 'Contenuto Lungo Scorrevole',
  'modal.backdrop': 'Sfondo',
  'modal.backdrop-value': 'Valore Sfondo',
  'modal.right-modal': 'Modale a Destra',
  'modal.launch-right-modal': 'Avvia Modale a Destra',
  'modal.nested-modal': 'Modale Annidato',
  'modal.size': 'Dimensione',
  'modal.launch-large-modal': 'Avvia Modale Grande',
  'modal.launch-small-modal': 'Avvia Modale Piccolo',

  /* 07.16.Navigazione */
  'nav.basic': 'Navigazione Base',
  'nav.active': 'Attivo',
  'nav.disabled': 'Disabilitato',
  'nav.disabled-link': 'Link Disabilitato',
  'nav.link': 'Link',
  'nav.longer-link': 'Link di navigazione più lungo',
  'nav.another-link': 'Altro Link',
  'nav.right': 'Destra',
  'nav.dropdown': 'Menu a Discesa',
  'nav.header': 'Intestazione',
  'nav.action': 'Azione',
  'nav.another-action': 'Altra Azione',
  'nav.horizontal-alignment': 'Allineamento Orizzontale',
  'nav.vertical-alignment': 'Allineamento Verticale',
  'nav.pills': 'Navigazione a Pillole',
  'nav.fill-justify': 'Riempimento e Giustificazione',
  'nav.pills-dropdowns': 'Pillole con Menu a Discesa',
  'nav.pagination-basic': 'Paginazione Base',
  'nav.pagination-sizing': 'Dimensione Paginazione',
  'nav.large': 'Grande',
  'nav.small': 'Piccolo',
  'nav.center': 'Centro',
  'nav.pagination-alignment': 'Allineamento Paginazione',
  'nav.breadcrumb-basic': 'Breadcrumb Base',
  'nav.dark-mode': 'Modalità Scura',
  'nav.log-out': 'Disconnettersi',
  'nav.maximize': 'Massimizza',

  /* 07.17.Tooltips e Popover */
  'popover-tooltip.popover': 'Popovers',
  'popover-tooltip.tooltip': 'Tooltip',

  /* 07.18.Ordinabile */
  'sortable.columns': 'Ordina Colonne',
  'sortable.basic': 'Base',
  'sortable.handles': 'Maniglie',

  /* 07.19.Mappe */
  'maps.google': 'Google',
  'maps.yandex': 'Yandex',

  /* 07.20.Tabelle */
  'table.bootstrap-tables': 'Tabelle Bootstrap',
  'table.bootstrap-basic': 'Tabelle di Base',
  'table.bootstrap-striped': 'Zebrate',
  'table.bootstrap-bordered': 'Tabelle con Bordi',
  'table.bootstrap-borderless': 'Tabelle senza Bordi',
  'table.bootstrap-hoverable': 'Tabelle Interattive',
  'table.bootstrap-responsive': 'Tabelle Responsive',
  'table.react-tables': 'Tabelle React',
  'table.react-pagination': 'Paginazione',
  'table.react-scrollable': 'Tabelle Scorrevoli',
  'table.react-advanced': 'Filtro, Lunghezza e Salto',
  'table.divided': 'Tabella Divisa',

  /* 07.21.Assistenti */
  'wizard.step-name-1': 'Passo 1',
  'wizard.step-name-2': 'Passo 2',
  'wizard.step-name-3': 'Passo 3',
  'wizard.step-desc-1': 'Descrizione del primo passo',
  'wizard.step-desc-2': 'Descrizione del secondo passo',
  'wizard.step-desc-3': 'Descrizione del terzo passo',
  'wizard.content-1': 'Contenuto per il primo passo.',
  'wizard.content-2': 'Contenuto per il secondo passo.',
  'wizard.content-3': "Contenuto dell'ultimo passo!",
  'wizard.content-thanks': 'Grazie!',
  'wizard.next': 'Successivo',
  'wizard.prev': 'Precedente',
  'wizard.registered': 'La tua registrazione è stata completata con successo!',
  'wizard.async': 'Salvataggio asincrono per 3 secondi!',

  /* 07.22.Errori */
  'error.401-not-authorized': 'Errore, sessione utente scaduta.',
  'error.403-not-authorized':
    "Errore, l'utente non ha il permesso, si consiglia di accedere nuovamente per ottenere i permessi corretti.",
  /* Modules */
  /* aiteaassistant_start_trans */
  'example.example': 'Esempio',
  'assistant.title': 'Aitea Assistant',
  'assistant.say.something': 'Chiedimi qualcosa',
  'assistant.action.delete': 'Elimina',
  'assistant.action.speaker': 'Connetti altoparlante',
  'assistant.action.microphone': 'Connetti microfono',
  'assistant.action.microphonestop': 'Metti in pausa il microfono',
  'assistant.action.attach': 'Allega documenti',
  'assistant.action.alerts': 'Aggiungi avvisi',
  'assistant.action.settings': 'Impostazioni',
  'assistant.action.logout': 'Disconnetti',
  'assistant.menu': 'Assistant',
  'assistant.initial.message': 'Bentornato',
  'assistant.greeting':
    'Ciao, [name]. Sono il tuo Assistente, lo strumento che permette di accedere in modo agile e semplice alle informazioni chiave del portfolio di Colonial, migliorare i KPI di manutenzione, risparmiare tempo nelle attività quotidiane e supportare il controllo qualità della manutenzione operativa.',
  'assistant.file.download': 'Scarica il documento richiesto',
  'assistant.file.error':
    'Errore durante il download del file. I file possono essere scaricati una sola volta. Per visualizzarlo nuovamente, è necessario richiederlo di nuovo.',
  'assistant.user.pronoun': 'Io',
  'assistant.delete.disclaimer':
    'Sei sicuro di voler eliminare la conversazione?',
  'assistant.delete.title': 'Elimina la cronologia della conversazione',
  'assistant.yesterday': 'Ieri',
  'assistant.today': 'Oggi',
  'assistant.thinking': 'Sto pensando...',
  'assistant.listening': 'Ascoltando...',
  'assistant.playing': 'Riproduzione...',
  'assistant.playback.speed': 'Velocità di riproduzione',
  'assistant.playback.close': 'Chiudi il lettore',
  'assistant.finish': 'Finire',
  'assistant.reasoning': 'Ragionamento',
  'assistant.feedback.title': "Com'è stata questa risposta?",
  'assistant.feedback.comment.placeholder': 'Commento (facoltativo)',
  'assistant.feedback.submit': 'Invia',
  'permissions.global.assistant.use': "Usare l'assistente",
  'permissions.global.assistant.use.description':
    "Fare domande all'assistente e consultare la propria cronologia delle chat.",
  'permissions.global.assistant.chatbot': 'Assistente in modalità chatbot',
  'permissions.global.assistant.chatbot.description':
    "Usare l'assistente come chatbot: risponde alle domande.",
  'permissions.global.assistant.agentic': 'Assistente in modalità agentica',
  'permissions.global.assistant.agentic.description':
    "Usare l'assistente in modalità agentica: oltre a rispondere, esegue azioni.",
  /* aiteaassistant_end_trans */
};
